import React, { useEffect, useState } from "react";
import GlobalHelmet from "./../../../GlobalHelmet";
import Loader from "./../../../component/Loader";
import RestService from "./../../../Restservice";
import Breadcrumbs from "./../../../component/breadcrumbs";
import "react-smart-data-table/dist/react-smart-data-table.css";
import OptionChainTable from "./OptionChainTable";
import OptionChart from "./../../../component/OptionChart";
import Common from "./../../../common.json";
import FAQ from "./FAQ";

export default function OptionDashboard() {
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [viewMode, setViewMode] = useState("table");

  useEffect(() => {
    setLoading(true);
    RestService.getFutureOption(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (response.data.response) {
          setglobaldata(response.data.response);
        }
      },
      mobile,
      web_token
    );
  }, [mobile, web_token]);

  const updateViewMode = (mode) => {
    setViewMode(mode);
  };

  return (
    <>
      {loading ? <Loader /> : ""}

      <GlobalHelmet {...Common?.futureDashboard} />
      <div className="bodycontainer">
        <div className="custom-auto-space">
          <div className="">
            {
              <div className="row">
                <div className="col-sm-12">
                  <div className="fixedAddButton">
                    <button
                      onClick={() => updateViewMode("table")}
                      className="btn btn-success"
                    >
                      Table View
                    </button>
                    <button
                      onClick={() => updateViewMode("graph")}
                      className="btn btn-primary ml-2"
                    >
                      Graph View
                    </button>
                  </div>
                  <Breadcrumbs page="Future Dashboard" />
                </div>
                <div className="col-sm-12">
                  <h1 className="highlighttext">Future Dashboard</h1>
                  <p>
                    Explore futures and options for future index, Stock, future
                    index Nifty and future index bank nifty. Do analysis of
                    active OI gainer stocks, active OI loser stocks, Active by
                    no of trades, Active by OI% gainer and Active by OI% loser,
                    Active by %price change, Active by no of contracts etc. Get
                    the most active future and options stocks & indexes like
                    bank nifty, nifty 50. Learn more about future and options
                    trading.
                  </p>
                </div>
              </div>
            }

            {viewMode === "graph" && (
              <div className="row">
                <div className="col-sm-6">
                  {globaldata.conresults && globaldata.conresults.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.conresults}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="Contracts"
                      heading="Active By Contracts"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-6">
                  {globaldata.oiresults && globaldata.oiresults.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.oiresults}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="OI"
                      heading="Active By OI"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-6">
                  {globaldata.oicresults && globaldata.oicresults.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.oicresults}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="OI Gainer"
                      heading="Active By OI Gainer"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-6">
                  {globaldata.traderesults &&
                  globaldata.traderesults.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.traderesults}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="Traded Value"
                      heading="Active By Traded Value(Crs.)"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-6">
                  {globaldata.pricecresults &&
                  globaldata.pricecresults.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.pricecresults}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="Price Chg"
                      heading="Active By Price(%CHG) Gainer"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-6">
                  {globaldata.oiGainer && globaldata.oiGainer.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.oiGainer}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="OI% Gainer"
                      heading="Active By OI% Gainer"
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-sm-6">
                  {globaldata.oiLoser && globaldata.oiLoser.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.oiLoser}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="OI% Loser"
                      heading="Active By OI% Loser"
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-sm-6">
                  {globaldata.volGainer && globaldata.volGainer.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.volGainer}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="Vol% Gainer"
                      heading="Active By Vol% Gainer"
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-sm-6">
                  {globaldata.volLoser && globaldata.volLoser.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.volLoser}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="Vol% Loser"
                      heading="Active By Vol% Loser"
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-sm-6">
                  {globaldata.oidcresults &&
                  globaldata.oidcresults.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.oidcresults}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="OI Loser"
                      heading="Active By OI Loser"
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div className="col-sm-6">
                  {globaldata.pricecDresults &&
                  globaldata.pricecDresults.length > 0 ? (
                    <OptionChart
                      getDetails={globaldata.pricecDresults}
                      label="symbol"
                      columnNameOne="close"
                      columnNameTwo="columnKey"
                      columnName="Price Chg"
                      heading="Active By Price(%CHG) Loser"
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            )}
            {viewMode === "table" && (
              <div className="news-original  ">
                <div className="row">
                  <div className="col-sm-4">
                    {globaldata.conresults &&
                    globaldata.conresults.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.conresults}
                        heading="Active By Contracts"
                        columnName="Contracts"
                        columnKey="contracts"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm-4">
                    {globaldata.oiresults && globaldata.oiresults.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.oiresults}
                        heading="Active By OI"
                        columnName="OI"
                        columnKey="open_int"
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-sm-4">
                    {globaldata.oicresults &&
                    globaldata.oicresults.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.oicresults}
                        heading="Active By OI Gainer"
                        columnName="OI Gainer"
                        columnKey="chg_in_ol"
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-sm-4">
                    {globaldata.traderesults &&
                    globaldata.traderesults.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.traderesults}
                        heading="Active By Traded Value(Crs.)"
                        columnName="Traded Value"
                        columnKey="val_inlakh"
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-sm-4">
                    {globaldata.pricecresults &&
                    globaldata.pricecresults.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.pricecresults}
                        heading="Active By Price(%CHG) Gainer"
                        columnName="Price Chg"
                        columnKey="cchg"
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-sm-4">
                    {globaldata.oiGainer && globaldata.oiGainer.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.oiGainer}
                        heading="Active By OI% Gainer"
                        columnName="OI% Gainer"
                        columnKey="oiper"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm-4">
                    {globaldata.oiLoser && globaldata.oiLoser.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.oiLoser}
                        heading="Active By OI% Loser"
                        columnName="OI% Loser"
                        columnKey="oiper"
                        order="ASC"
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-sm-4">
                    {globaldata.volGainer && globaldata.volGainer.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.volGainer}
                        heading="Active By Vol% Gainer"
                        columnName="Vol% Gainer"
                        columnKey="volperct"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm-4">
                    {globaldata.volLoser && globaldata.volLoser.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.volLoser}
                        heading="Active By Vol% Loser"
                        columnName="Vol% Loser"
                        columnKey="volperct"
                        order="ASC"
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-sm-4">
                    {globaldata.oidcresults &&
                    globaldata.oidcresults.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.oidcresults}
                        heading="Active By OI Loser"
                        columnName="OI Loser"
                        columnKey="chg_in_ol"
                        order="ASC"
                      />
                    ) : (
                      ""
                    )}
                  </div>

                  <div className="col-sm-4">
                    {globaldata.pricecDresults &&
                    globaldata.pricecDresults.length > 0 ? (
                      <OptionChainTable
                        results={globaldata.pricecDresults}
                        heading="Active By Price(%CHG) Loser"
                        columnName="Price Chg"
                        columnKey="cchg"
                        order="ASC"
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-sm-12">
              <FAQ />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
